// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #dfdfdf;
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/inbox/inbox.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AACJ","sourcesContent":["hr {\n    display: block;\n    height: 1px;\n    border: 0;\n    border-top: 1px solid #dfdfdf;\n    margin-top: 5px;\n    margin-bottom: 5px;\n    padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
